import type { User } from '../types'

import { baseApi } from './baseApi'
import type {
    ResponseType,
    LoginRequestType,
    LoginResponseType,
    RegisterResponseType,
} from './types'

const authBase = 'api/auth'

export const authApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation<LoginResponseType, LoginRequestType>({
            query: (body) => ({
                url: `${authBase}/signin?appType=web`,
                method: 'POST',
                body,
            }),
        }),
        logout: builder.query<void, void>({
            query: () => `${authBase}/logout`,
        }),
        forgotPassword: builder.mutation<
            ResponseType<undefined>,
            { email: string }
        >({
            query: (body) => ({
                url: `${authBase}/forgot-password`,
                method: 'POST',
                body,
            }),
        }),
        testForgotCode: builder.mutation<
            ResponseType<undefined>,
            { email: string; code: number }
        >({
            query: (body) => ({
                url: `${authBase}/test-forgot-code`,
                method: 'POST',
                body,
            }),
        }),
        restorePassword: builder.mutation<
            RegisterResponseType,
            { email: string; code: number; password: string }
        >({
            query: (body) => ({
                url: `${authBase}/restore-password`,
                method: 'POST',
                body,
            }),
        }),

        getMe: builder.query<ResponseType<User>, void>({
            query: () => `api/users/me`,
            providesTags: ['me'],
        }),
        updateMe: builder.mutation<ResponseType<User>, FormData>({
            query: (body) => ({
                url: `api/users/me`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['me'],
        }),
    }),
})

export const {
    useLoginMutation,
    useGetMeQuery,
    useLazyGetMeQuery,
    useUpdateMeMutation,
    useLazyLogoutQuery,
    useForgotPasswordMutation,
    useTestForgotCodeMutation,
    useRestorePasswordMutation,
} = authApi
